import { rejected, resolved } from 'store/createAction';
import {
  DELETE_MESSAGE,
  GET_PENDING_MESSAGES,
  TOGGLE_MESSAGES_TYPE,
} from '../types';

const initialState = {
  loading: false,
  hasMore: true,
  isGroup: false,
  data: [],
  limit: 30,
  offset: 0,
};

export default (state = initialState, action) => {
  const { type, payload, meta } = action;
  switch (type) {
    case GET_PENDING_MESSAGES:
      return {
        ...state,
        loading: true,
      };
    case resolved(GET_PENDING_MESSAGES): {
      if (meta.reset) {
        return {
          ...state,
          loading: false,
          data: payload,
          offset: meta.query.offset,
          hasMore: payload.length === meta.query.limit,
        };
      }
      return {
        ...state,
        loading: false,
        data: [...state.data, ...payload],
        offset: meta.query.offset,
        hasMore: payload.length === meta.query.limit,
      };
    }

    case rejected(GET_PENDING_MESSAGES):
      return {
        ...state,
        loading: false,
      };

    case TOGGLE_MESSAGES_TYPE: {
      if (payload.type === 'pending') {
        return {
          ...state,
          isGroup: payload.isGroup,
        };
      }
      return state;
    }

    case resolved(DELETE_MESSAGE): {
      return {
        ...state,
        data: state.data.filter((d) => d.hash !== meta.id),
      };
    }

    default:
      return state;
  }
};
